import * as React from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { add, LogsLookup, updateClient } from "../../service/clientService";
import { Button } from "primereact/button";
import DropdownApi from "../../components/DropdownApi";
import { UserSession } from "../../models/UserSession";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import { Grid } from "@mui/material";
import ImageS3Upload from "../../components/ImageS3Upload";
import { placeholder } from "../../assets/placeholder";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { InputIcon } from "primereact/inputicon";
import { InputSwitch } from "primereact/inputswitch";
import Input from "@mui/joy/Input";

export default function ClientAdd(modalProps: any) {
  const record = modalProps.record || {};

  async function addClient() {
    let createObject: any = {
      industry,
      name,
      contact_person: contactPerson,
      email,
      mobile,
      user_id: userId,
      s3_key: !!file ? `client/${id}` : undefined,
      fund_registration_number: fundRegistration,
      vat_registration_number: vatRegistration,
      company_registration_number: companyRegistration,
      allow_admin_sign: allowAdminsToSign,
    };
    if (!!consultant) {
      createObject.consultant = consultant;
    }
    modalProps.setGlobalLoading(true);
    if (record?.id) {
      updateClient(createObject, record?.id).then((r: any) => {
        modalProps.setGlobalLoading(false);
        modalProps.toast.current.show({
          severity: "success",
          summary: "Client Updated Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setReload(!modalProps.reload);
      });
      return;
    }
    add(createObject).then((r: any) => {
      modalProps.setGlobalLoading(false);
      modalProps.toast.current.show({
        severity: "success",
        summary: "Client Added Successfully",
        life: 3000,
      });
      modalProps.setVisible(false);
      modalProps.setReload(!modalProps.reload);
    });
  }

  const session: UserSession = modalProps.session;

  const id = modalProps?.uuid;

  const [industry, setIndustry] = React.useState(record?.industry || []);
  const [consultant, setConsultant] = React.useState(
    record?.consultant || session?.consultant_id || ""
  );
  const [name, setName] = React.useState(record?.name || "");
  const [contactPerson, setContactPerson] = React.useState(record?.contact_person || "");
  const [mobile, setMobile] = React.useState(record?.mobile || "");
  const [email, setEmail] = React.useState(record?.email || "");

  const [vatRegistration, setVatRegistration] = React.useState(
    record?.vat_registration_number || ""
  );
  const [companyRegistration, setCompanyRegistration] = React.useState(
    record?.company_registration_number || ""
  );
  const [fundRegistration, setFundRegistration] = React.useState(
    record?.fund_registration_number || ""
  );

  const [fundShowValidation, setFundShowValidation] = React.useState(false);
  const [fundIdError, setFundIdError] = React.useState(false);
  const [fundIdLoader, setFundIdLoader] = React.useState(false);

  const [certificateNumber, setCertificateNumber] = React.useState("");
  const [expiryDate, setExpiryDate] = React.useState("");
  const [issueDate, setIdIssueDate] = React.useState("");
  const [tradeName, setTradeName] = React.useState("");

  const [userId, setUserId] = React.useState(record?.user_id || "");
  const [photo, setPhoto] = React.useState(record?.photo || placeholder);
  const [file, setFile] = React.useState<File>();
  const [activeStep, setActiveStep] = React.useState(0);
  const [allowAdminsToSign, setAllowAdminsToSign] = React.useState(
    record?.allow_admin_sign || false
  );

  const stepperRef = React.useRef<any>(null);

  React.useEffect(() => {}, [file]);

  async function Next() {
    setActiveStep(activeStep + 1);
    stepperRef?.current?.nextCallback();
  }

  async function Back() {
    setActiveStep(activeStep - 1);
    stepperRef?.current?.prevCallback();
  }

  async function LogsVerifyID() {
    if (!fundRegistration) return;
    setFundIdLoader(true);
    setFundShowValidation(true);
    LogsLookup(fundRegistration)
      .then((r: any) => {
        console.log("LogsVerifyID r == ", r);
        setFundIdLoader(false);
        if (!r?.certificateNumber) {
          setFundIdError(true);
          return;
        }
        setCertificateNumber(r.certificateNumber);
        setExpiryDate(r.expiryDate);
        setIdIssueDate(r.issueDate);
        setTradeName(r.tradeName);
        setFundIdError(false);
      })
      .catch(error => {
        setFundIdLoader(false);
        setFundIdError(true);
      });
  }

  return (
    <React.Fragment>
      <Stepper ref={stepperRef} linear={true}>
        <StepperPanel header="Details">
          <div>
            <div style={{ display: "flex", gap: "2rem", marginBottom: "2rem" }}>
              <FormControl>
                <ImageS3Upload
                  photo={photo}
                  setPhoto={setPhoto}
                  s3Key={`client/${id}`}
                  file={file}
                  setFile={setFile}
                />
              </FormControl>
              <div style={{ width: "50%" }}>
                <FormLabel style={{ marginBottom: "0.5rem" }}>
                  Company Name<div style={{ color: "red" }}>*</div>
                </FormLabel>
                <Input
                  value={name}
                  size="sm"
                  placeholder="Company Name"
                  onChange={e => setName(e.target.value)}
                />

                <div>
                  <MultiDropdownApi
                    required={true}
                    apiPath="industry"
                    optionLabel="name"
                    optionValue="id"
                    label="Industry"
                    selectedData={industry}
                    setSelectedData={setIndustry}
                  />
                </div>
              </div>
            </div>

            {!!session?.consultant_id ? (
              ""
            ) : (
              <Grid item xs={12}>
                <DropdownApi
                  apiPath="consultant"
                  optionLabel="name"
                  optionValue="id"
                  label="Consultant"
                  selectedData={consultant}
                  setSelectedData={setConsultant}
                />
              </Grid>
            )}
          </div>
        </StepperPanel>
        <StepperPanel header="Registration">
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormControl>
                <FormLabel>VAT Registration Number</FormLabel>
                <Input
                  value={vatRegistration}
                  size="sm"
                  placeholder="VAT Number"
                  onChange={e => setVatRegistration(e.target.value)}
                />
              </FormControl>
            </Grid>

            <Grid item xs={6}>
              <FormControl>
                <FormLabel>Company Registration Number</FormLabel>
                <Input
                  value={companyRegistration}
                  size="sm"
                  placeholder="Registration Number"
                  onChange={e => setCompanyRegistration(e.target.value)}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl>
                <FormLabel>
                  Compensation Fund Registration Number (Letter of Good Standing){" "}
                  <a
                    style={{ marginLeft: 15 }}
                    href="https://cfonline.labour.gov.za/VerifyLOGS"
                    target="_blank"
                  >
                    Search
                  </a>
                </FormLabel>
                <Input
                  size="sm"
                  placeholder="Registration Number"
                  value={fundRegistration}
                  onChange={e => setFundRegistration(e.target.value)}
                  onBlur={LogsVerifyID}
                  endDecorator={
                    fundIdLoader ? (
                      <InputIcon className="pi pi-spin pi-spinner" />
                    ) : !fundShowValidation ? (
                      ""
                    ) : fundIdError ? (
                      <InputIcon className="pi pi-times-circle" style={{ color: "red" }} />
                    ) : (
                      <InputIcon className="pi pi-verified" style={{ color: "green" }} />
                    )
                  }
                />
              </FormControl>
            </Grid>
          </Grid>
          <br />
          {fundIdError || !certificateNumber ? (
            ""
          ) : (
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormControl>
                  <FormLabel>Certificate Number</FormLabel>
                  <Input
                    value={certificateNumber}
                    size="sm"
                    placeholder="Certificate Number"
                    readOnly
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl>
                  <FormLabel>Trade Name</FormLabel>
                  <Input value={tradeName} size="sm" placeholder="Trade Name" readOnly />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl>
                  <FormLabel>Issue Date</FormLabel>
                  <Input value={issueDate} size="sm" placeholder="Issue Date" readOnly />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl>
                  <FormLabel>Expiry Date</FormLabel>
                  <Input value={expiryDate} size="sm" placeholder="Expiry Date" readOnly />
                </FormControl>
              </Grid>
            </Grid>
          )}
        </StepperPanel>
        <StepperPanel header="Admin">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl>
                <FormLabel>ContactDetails Person</FormLabel>
                <Input
                  value={contactPerson}
                  size="sm"
                  placeholder="ContactDetails Person"
                  onChange={e => setContactPerson(e.target.value)}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl>
                <FormLabel>ContactDetails number</FormLabel>
                <PhoneInput
                  defaultCountry="za"
                  value={mobile}
                  style={{ width: "100%" }}
                  onChange={e => setMobile(e)}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl sx={{ flexGrow: 1 }}>
                <FormLabel>
                  Email<div style={{ color: "red" }}>*</div>
                </FormLabel>
                <Input
                  size="sm"
                  type="email"
                  startDecorator={<EmailRoundedIcon />}
                  placeholder="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  sx={{ flexGrow: 1 }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl>
                <FormLabel>Allow Admins To Sign</FormLabel>
                <InputSwitch
                  checked={allowAdminsToSign}
                  onChange={e => setAllowAdminsToSign(e.value)}
                />
              </FormControl>
            </Grid>
          </Grid>
        </StepperPanel>
      </Stepper>
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: "flex-end", pt: 2 }}>
          {activeStep > 0 ? (
            <Button
              type="button"
              icon="pi pi-arrow-left"
              label="Back"
              className="p-button-outlined"
              size="small"
              style={{ position: "absolute", fontSize: "small", right: 100 }}
              onClick={() => Back()}
            />
          ) : (
            ""
          )}
          {activeStep != 2 ? (
            <Button
              type="button"
              icon="pi pi-arrow-right"
              label="Next"
              className="p-button-outlined"
              size="small"
              style={{ position: "absolute", fontSize: "small", right: 0 }}
              onClick={() => Next()}
            />
          ) : (
            ""
          )}
          {activeStep == 2 ? (
            <Button
              type="button"
              icon="pi pi-save"
              label="Save"
              className="p-button-outlined"
              size="small"
              style={{
                position: "absolute",
                fontSize: "small",
                right: 0,
                color: "#2dd36f",
              }}
              onClick={() => addClient()}
            />
          ) : (
            ""
          )}
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
